import firebase from '../../lib/firebase.prod';
import * as PROJECT_CODE from '../../constants/projectCode';
import dayjs from 'dayjs';

const firebaseRef = firebase.database();

export default async function setBookedAppointment(
	salesAgentId,
	email,
	fullName,
	phoneNumber,
	time,
	setAlert,
	setFinishAppointment,
	setOpenDetailsForm,
	setDisabled
) {
	firebase
		.database()
		.ref('/client_appointments/' + PROJECT_CODE.projectCode)
		.once('value', async (snapshot) => {
			let appointmentsParent = snapshot.val();
			if (appointmentsParent) {
				let appointmentsKeys = Object.keys(appointmentsParent);
				let filteredAppointmentKeys = appointmentsKeys
					.filter((appointmentsKey) => {
						return (
							appointmentsParent[appointmentsKey].users['0']
								.email === email
						);
					})
					.filter((appointmentsKey) => {
						// Need to compare without milliseconds
						let timeInput = dayjs(time);
						let timeParent = dayjs(
							appointmentsParent[appointmentsKey]
								.timeOfAppointment
						);
						return timeInput.diff(timeParent, 'hour') === 0;
					});
				if (filteredAppointmentKeys.length === 0) {
					var salesAgentObj;
					var salesAgentString = `/users/${salesAgentId}`;

					await firebaseRef
						.ref(salesAgentString)
						.once('value', (snapshot) => {
							let agentUser = snapshot.val();
							console.log(
								'getSalesAgentDetails snapshot',
								agentUser
							);
							if (agentUser) {
								var agentName = agentUser?.fullName;
								var agnetEmail = agentUser?.email;
								var agentPhoneNumber = agentUser?.phoneNumber;
								salesAgentObj = {
									name: agentName,
									email: agnetEmail,
									phoneNumber: agentPhoneNumber,
								};
							}
						});
					if (salesAgentObj && salesAgentObj?.name) {
						var appointmentPost = {
							appointmentID: 'none',
							appointmentName: `${fullName} meeting with ${salesAgentObj.name}`,
							salesAgentEmail: `${salesAgentObj.email}`,
							salesAgentName: `${salesAgentObj.name}`,
							timeOfAppointment: parseInt(time),
							assignedTo: salesAgentId,
							started: false,
							createrID: salesAgentId,
							sentRemind: false,
							createUser: true,
							createTimestamp: new Date().getTime(),
							projectCode: PROJECT_CODE.projectCode,
						};

						var users = {
							0: {
								email: email,
								fullName: fullName,
								phoneNumber: phoneNumber,
							},
						};

						appointmentPost['users'] = users;

						var createNewAppointment = await firebase
							.functions()
							.httpsCallable('CreateMeetingFromData');

						var shortCode;

						await createNewAppointment(appointmentPost)
							.then((result) => {
								console.log(
									'results: ' + result.data.shortCode
								);
								shortCode = result.data.shortCode;
								setAlert &&
									setAlert(
										'success',
										'Create appointment successfully. Please wait a few seconds to take effect'
									);
								setFinishAppointment &&
									setFinishAppointment(true);
							})
							.catch(function (error) {
								console.log('Error ' + error);
								setAlert &&
									setAlert(
										'error',
										'Fail to create appointment.'
									);
								setOpenDetailsForm && setOpenDetailsForm(false);
								setDisabled && setDisabled(false);
							});
					} else {
						// When there is no sales agent data in /users/${salesAgentId}
						setAlert &&
							setAlert(
								'warning',
								'No sales agents are available at this time slot.'
							);
						setOpenDetailsForm(false);
					}
				} else {
					setAlert(
						'error',
						'This time slot has been booked. Please try again.'
					);
					setOpenDetailsForm && setOpenDetailsForm(false);
					// setDisabled && setDisabled(false);
				}
			} else {
				var salesAgentObj;
				var salesAgentString = `/users/${salesAgentId}`;

				await firebaseRef
					.ref(salesAgentString)
					.once('value', (snapshot) => {
						let agentUser = snapshot.val();
						if (agentUser) {
							var agentName = agentUser?.fullName;
							var agnetEmail = agentUser?.email;
							var agentPhoneNumber = agentUser?.phoneNumber;
							salesAgentObj = {
								name: agentName,
								email: agnetEmail,
								phoneNumber: agentPhoneNumber,
							};
						}
					});
				if (salesAgentObj && salesAgentObj?.name) {
					var appointmentPost = {
						appointmentID: 'none',
						appointmentName: `${fullName} meeting with ${salesAgentObj.name}`,
						timeOfAppointment: parseInt(time),
						assignedTo: salesAgentId,
						started: false,
						createrID: salesAgentId,
						sentRemind: false,
						createUser: true,
						createTimestamp: new Date().getTime(),
						projectCode: PROJECT_CODE.projectCode,
					};

					var users = {
						0: {
							email: email,
							fullName: fullName,
							phoneNumber: phoneNumber,
						},
					};

					appointmentPost['users'] = users;

					var createNewAppointment = await firebase
						.functions()
						.httpsCallable('CreateMeetingFromData');

					var shortCode;

					await createNewAppointment(appointmentPost)
						.then((result) => {
							console.log('results: ' + result.data.shortCode);
							shortCode = result.data.shortCode;
							setAlert &&
								setAlert(
									'success',
									'Create appointment successfully. Please wait a few seconds to take effect'
								);
							setFinishAppointment && setFinishAppointment(true);
						})
						.catch(function (error) {
							console.log('Error ' + error);
							setAlert &&
								setAlert(
									'error',
									'Fail to create appointment.'
								);
							setOpenDetailsForm && setOpenDetailsForm(false);
							setDisabled && setDisabled(false);
						});
				} else {
					// When there is no sales agent data in /users/${salesAgentId}
					setAlert &&
						setAlert(
							'warning',
							'No sales agents are available at this time slot.'
						);
					setOpenDetailsForm(false);
				}
			}
		});
}
